module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-text-e1e444e2.svg";